import axios from "axios";
import qs from "qs";
import localforage from "localforage";
import support from "../../plugins/support";
import Cookies from "js-cookie";



axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT_URL;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.withCredentials = true;

export const sharedModule = {
  namespaced: true,
  state: () => ({
    dbName: "",
    tabletCode: null,
    coordinates: null,
    version: "",
    app_name: "",
    gpsOn: false,
    status: "",
    username: "",
    loggedIn: false,
    observerCode: null,
    unsavedData: false,
    unfinishedSearch: null,
    siteUrl: "",
    ref_hotel: [],
    access_level:"user",
    loginError: "",
  }),
  getters: {
    access_level: (state) => state.access_level,
    dbName: (state) => state.dbName,
    tabletCode: (state) => state.tabletCode,
    authStatus: (state) => state.status,
    username: (state) => state.username,
    isLoggedIn: (state) => state.loggedIn,
    observerCode: (state) => state.observerCode,
    version: (state, getters, rootState) => rootState.app.pkg.version,
    app_name: (state, getters, rootState) => rootState.app.pkg.name,
    refHotel: (state) => state.ref_hotel,
    locationOn: (state) => state.coordinates != null,
    getAttribute: (state) => (attribute) => state[attribute],
    siteUrl: (state, getters, rootState) => rootState.app.siteUrl,
    isIncidental: (state, getters, rootState) => rootState.app.incidental != undefined ? rootState.app.incidental : false,
    dataTables: (state, getters, rootState) => rootState.app.dataTables,
    refTables: (state, getters, rootState) => rootState.app.refTables,
    views: (state, getters, rootState) => rootState.app.views,
    tablePositions: (state, getters, rootState) => rootState.app.tablePositions,
    unfinishedSearch: (state) => state.unfinishedSearch,
  },
  mutations: {
    setAttribute(state, info) {
      state[info.attribute] = info.value;
    },
    setUnsavedData(state, value) {
      state.unsavedData = value;
    },
    setDbName(state, dbName) {
      if(dbName != '' && dbName != undefined ) {
      console.log(Cookies.get("auth"))
      if (Cookies.get("auth") !== undefined) {
        state.dbName = dbName;
        localforage.setItem("dbName", dbName);
        let access_level = "user"
            
        axios.get(`${state.dbName}/logged_in/`)
        //axios.get(`logged_in/`)
        .then((response) => {
          if (response.status === 200) {
            access_level = response.data.AccessLevel; 
          }
          state.access_level = access_level;
          localforage.setItem("access_level", access_level);
        }
        ).catch((err) => {
          //TODO need to send back to login and database name should be cleared.
          console.log(`Error fetching access level: ${err.message}`);
          state.access_level = access_level;
          localforage.setItem("access_level", access_level);
        });

      }
     
    }
    },
    setTabletCode(state, tabletCode) {
      state.tabletCode = tabletCode;
    },
    auth_request(state) {
      state.loginError = "";
      state.status = "loading";
      state.loggedIn = false;
      state.username = "guest";
    },
  
    auth_success(state, user) {
      //populate the possible databases
      axios.get(`/user_info/`)
      //axios.get(`logged_in/`)
      .then((response) => {
        if (response.status === 200) {
          user.databases = response.data.map((el) => el.DatabaseName)
          
        } else {
          user.databases = ["avian_downed_bird_test"]
        }
        if (user.databases != undefined) {
          state.ref_hotel = user.databases
        }
      }).catch((err) => {
          console.log(`Error fetching databases: ${err.message}`);
          user.access_level = "user"; // default access level
          user.databases = ["avian_downed_bird_test"]
        });

        state.status = "success";
        state.loggedIn = true;
        state.username = user.username;
    },
    auth_error(state) {
      state.status = "error";
      state.loggedIn = false;
      Cookies.remove("auth");
    },
    logout(state) {
      state.status = "";
      state.dbName = "";
      state.loggedIn = false;
      state.username = "guest";
      
      //reset all the table key positions to they're starting position
      //If the user doesn't reset after logging out and returns to a search the positions can be out of 
      //sync with the actual records
      Object.keys(this.getters["shared/tablePositions"]).forEach(async (key) => {
        this.getters["shared/tablePositions"][key] = -1
      });
      localforage.setItem("user", "guest");
      localforage.setItem("dbName", "");
      localforage.removeItem("auth", "");
      localforage.removeItem("lastRun", "");
      localforage.removeItem("access_level", "");
      Cookies.remove("auth");
    },
    setObserverCode(state, observerCode) {
      state.observerCode = observerCode;
    },
    lookUpUserName(state) {
      localforage.getItem("user").then((res) => {
        state.username = res;
        if (state.username === "") {
          state.username = Cookies.get("auth")["user"];
        }
      });
    },
    refreshRecords(state, {myState, payload}) {
      if (payload.tableType != null) {
        myState[payload.tableType][payload.tableName] = payload.records;
      } else {
        state[payload.tableName] = payload.records;
      }
    },
    addRecord(state, {myState, info}) {
      if (myState.dataTables[info.table]) {
        myState.dataTables[info.table].push(info.record);
      }else {
        myState.dataTables[info.table] = [info.record];
      }
    },
    shiftPosition(state, {myState, info}) {
        myState.tablePositions[info.table] = info.position;
    },
    setCoordinates(state, coords) {
      state.coordinates = coords;
    },
    setGPSState(state, gpsState) {
      state.gpsOn = gpsState;
    },
  },
  actions: {
    async setDbName({ commit }, dbName) {
      if (dbName && dbName.length > 0) {
        await localforage.setItem("dbName", dbName);
      } else {
        await localforage.getItem("dbName").then(function (value) {
          if (value) {
            dbName = value;
          }
        });
      }
      commit("setDbName", dbName);
    },
    async setTabletCode({ commit }) {
      let tabletCode = null;
      await Promise.all([
        localforage.getItem("tabletCode").then(function (value) {
          if (value) {
            tabletCode = value;
          } else {
            tabletCode = "";
            let characters = "ABCDEF0123456789";
            let charactersLength = characters.length;
            for (let i = 0; i < 6; i++) {
              tabletCode += characters.charAt(
                Math.floor(Math.random() * charactersLength)
              );
            }
            localforage.setItem("tabletCode", tabletCode);
          }
        }),
      ]);
      commit("setTabletCode", tabletCode);
    },
    async login({ commit }, user) {
      commit("auth_request");
      await axios
        //.post(`${user.dbName}/login/`, qs.stringify(user))
        .post(`login/`, qs.stringify(user))
        .then((response) => {
          if (response.status === 200) {
            
            let dt = new Date();
            localforage.setItem("lastRun", support.getLocalTimestamp(dt));

            localforage.setItem("user", user.username);
              commit("auth_success", user); //set when database is set
          } else {
            commit("auth_error");
          }
        })
        .catch((err) => {
          console.log(`err: ${err.message}`);
          //tell the user why so a network problem isn't mistaken for a bad password
          let message;
          if (!err.response) {
            message = "Could not reach the server. Check your connection and try again.";
          } else if (err.response.status === 401) {
            message = "Incorrect username or password.";
          } else {
            message = `Server error (${err.response.status}). Please try again.`;
          }
          commit("setAttribute", { attribute: "loginError", value: message });
          commit("auth_error");
        });
    },
    //The server renews the auth cookie's 30 day expiry each time logged_in is called,
    //so call it periodically while the app is in use
    async renewSession({ state }) {
      if (!state.loggedIn || !state.dbName) {
        return;
      }
      await axios
        .get(`${state.dbName}/logged_in/`)
        .catch((err) => console.log(`Could not renew session: ${err.message}`));
    },
    async logout({ commit }) {
      await axios
        .post(`logout/`)
        .then((response) => {
          if (response.status == 200) {
            commit("logout");
          } else {
            console.log("logout error!");
            commit("logout");
          }
        })
        .catch((err) => {
          console.log("logout error " + err);
          commit("logout");
        });
    },
    async checkAuthentication({ commit }) {
      if (Cookies.get("auth")) {
        localforage
          .getItem("dbName")
          .then((dbname) => (this.getters['shared/dbName'] = dbname))
          .catch((er) => console.log(er));

        localforage
          .getItem("user")
          .then((username) => {
            let user = {username: username, access_level: "user"}; //default access level
            localforage
              .getItem("access_level")
              .then((access_level) => {
                if (access_level) {
                  user.access_level = access_level;
                }
              })
              .catch((er) => console.log(er));
            if (user.username != 'guest' && user.username != '' && user.username != undefined) {
               commit("auth_success", user);
            }
          })
          .catch((er) => console.log(er));
      }
    },
    refreshRecords({ commit, rootState }, payload ){
      const app = rootState.app
      commit('refreshRecords', {myState: app, payload:payload})
    },
    addRecord({ commit, rootState }, info){
      const app = rootState.app
      commit('addRecord', {myState: app, info: info})
    },
   shiftPosition({ commit, rootState }, info ){
      const app = rootState.app
      commit('shiftPosition', {myState: app, info: info})
    }
  },
  modules: {},
}
